import { createSlice } from "@reduxjs/toolkit";

import { getZohoCredential } from "./leadZohoCredentials.asyncActions";

const initialState = {
    leadZohoCredentials: {
        message: "",
        status: "idle",
        credentials: [],
    },
};

export const leadZohoCredentialsSlice = createSlice({
    name: "leadZohoCredentialSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getZohoCredential.pending, (state) => {
                state.leadZohoCredentials.status = "loading";
            })
            .addCase(getZohoCredential.fulfilled, (state, action) => {
                state.leadZohoCredentials.status = "success";
                state.leadZohoCredentials.credentials =
                    action.payload.data && action.payload.data;
                state.leadZohoCredentials.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getZohoCredential.rejected, (state, action) => {
                state.leadZohoCredentials.status = "failed";
                state.leadZohoCredentials.message =
                    action.payload.message && action.payload.message;
            });
    },
});

export default leadZohoCredentialsSlice.reducer;
